// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__N2D6A","title":"FrontImage_title__106EG"};